import React from 'react';
import { motion } from 'framer-motion';
import { ProcessedOfficer, TierKey } from '../lib/officerUtils';
interface FloorDistributionProps {
  officers: ProcessedOfficer[];
}
const TIER_ORDER: TierKey[] = ['pacesetter', 'climbing', 'steady', 'coaching'];
const TIER_META: Record<TierKey, {
  label: string;
  color: string;
  textOn: string;
}> = {
  pacesetter: {
    label: 'Pacesetters',
    color: '#28A745',
    textOn: '#FFFFFF'
  },
  climbing: {
    label: 'Climbing',
    color: '#003B70',
    textOn: '#FFFFFF'
  },
  steady: {
    label: 'Steady',
    color: '#E9ECEF',
    textOn: '#333333'
  },
  coaching: {
    label: 'Needs Coaching',
    color: '#DC3545',
    textOn: '#FFFFFF'
  }
};
export function FloorDistribution({
  officers
}: FloorDistributionProps) {
  const valid = officers.filter(o => o.loginMin > 0);
  const total = valid.length;
  const counts: Record<TierKey, number> = {
    pacesetter: 0,
    climbing: 0,
    steady: 0,
    coaching: 0
  };
  valid.forEach(o => {
    counts[o.tier] += 1;
  });
  return <section className="w-full px-8 lg:px-12 xl:px-16 pb-12" data-id="element-42">
      <div className="flex items-baseline justify-between mb-5" data-id="element-43">
        <div data-id="element-44">
          <div className="font-serif font-bold text-xs tracking-[0.28em] uppercase text-primary/70 mb-2" data-id="element-45">
            Floor Distribution
          </div>
          <h2 className="font-serif font-bold text-2xl text-primary" data-id="element-46">
            How the floor is performing
          </h2>
        </div>
        <div className="text-xs uppercase tracking-[0.22em] text-primary/50 tabular-nums font-bold" data-id="element-47">
          {total} loan officers on the floor
        </div>
      </div>

      <div className="h-14 flex w-full rounded-sm overflow-hidden border border-ink-10 bar-shadow-inset" data-id="element-48">
        {TIER_ORDER.map((tier, i) => {
        const count = counts[tier];
        const pct = total > 0 ? count / total * 100 : 0;
        if (count === 0) return null;
        const meta = TIER_META[tier];
        const showInline = pct >= 12;
        return <motion.div key={tier} initial={{
          width: 0
        }} animate={{
          width: `${pct}%`
        }} transition={{
          duration: 0.8,
          delay: 0.15 + i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} style={{
          backgroundColor: meta.color,
          color: meta.textOn
        }} className="h-full flex items-center justify-between px-4 relative overflow-hidden" data-id="element-49">
              {showInline && <>
                  <span className="text-[11px] uppercase tracking-[0.2em] font-medium opacity-90 whitespace-nowrap" data-id="element-50">
                    {meta.label}
                  </span>
                  <span className="font-serif text-lg tabular-nums" data-id="element-51">
                    {count}
                  </span>
                </>}
            </motion.div>;
      })}
      </div>

      <div className="flex flex-wrap items-center gap-6 mt-4" data-id="element-52">
        {TIER_ORDER.map(tier => {
        const meta = TIER_META[tier];
        const count = counts[tier];
        const pct = total > 0 ? count / total * 100 : 0;
        return <div key={tier} className="flex items-baseline gap-2" data-id="element-53">
              <span className="w-2 h-2 rounded-full" style={{
            backgroundColor: meta.color
          }} data-id="element-54" />
              <span className="text-sm text-ink-70" data-id="element-55">{meta.label}</span>
              <span className="text-sm text-ink-50 tabular-nums" data-id="element-56">
                {count}
                <span className="text-ink-30" data-id="element-57"> · {pct.toFixed(0)}%</span>
              </span>
            </div>;
      })}
      </div>
    </section>;
}